<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
			    <span class="topTitle">新增分类</span>
			  </div>
			<el-form ref="addBody" :rules="rules" :model="addBody" label-position='top'>
				<el-form-item label="分类标题" prop="area_name" :label-width="formLabelWidth">
					<el-input v-model="addBody.area_name" placeholder="请输入分类标题" style="width: 432px;"></el-input>
				</el-form-item>
				
				<el-form-item label="所属类目" prop="area_name" :label-width="formLabelWidth">
					<el-select v-model="addBody.area_name" style="width: 432px;" placeholder="请选择所属类目">
					    <el-option
					      v-for="item in options"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
					  </el-select>
				</el-form-item>
				
				<div  class="dialog-footer">
					<el-button @click="goBack">取 消</el-button>
					<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
				</div>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import ImageUpload from "@/components/ImageUpload"
	export default {
		components: {
			ImageUpload
		},
		data() {
			return {
				formLabelWidth: '120px',
				addBody: {
					area_name: '',
					mobile: '',
					uuid: '',
					role_uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					area_name: [{
						required: true,
						message: '请输入视频标题',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, ]
				},
			}
		},
		methods: {
			goBack(){
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateRoleEmployee()
						} else {
							this.network().regionsave()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					regionsave: async () => {
						const {
							status,
							data
						} = await regionsave({
							area_name: this.addBody.area_name,
							parent_id: 0,
							level: 1
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateRoleEmployee: async () => {
						const {
							status
						} = await updateRoleEmployee({
							name: this.addBody.name,
							mobile: this.addBody.mobile,
							uuid: this.addBody.uuid,
							avatar: this.images[0]
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					EmployeeDetail: async (uuid) => {
						const {
							data,
							status
						} = await EmployeeDetail(uuid)
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.avatar != null) {
							this.images.push(data.result.avatar)
						}
					},
				}
			},
		},
	}
</script>

<style>
.el-icon-back{
	font-size: 22px !important;
	cursor: pointer;
}
</style>